export const webview = {
  webviewContent: 'Este é um URL externo e será aberto em uma nova janela. Abrir?',
  webviewButtonOpenTitle: 'Abrir',
  webviewButtonCopyTitle: 'Copiar URL',
  webviewButtonOpenAgainTitle: 'Abrir novamente',
  notifications: {
    urlCopied: 'URL copiado!'
  }
}
